export const punchoutCataloguesEndpoints = {
  listPunchoutCatalogues: { method: 'get', path: '/catalogues' },
  getPunchoutSession: { method: 'get', path: '/sessions/{id}' },
  createPunchoutSession: { method: 'post', path: '/sessions' },
  completePunchoutSession: { method: 'post', path: '/sessions/{id}/complete' },
  createPunchoutCatalogue: { method: 'post', path: '/catalogues' },
  updatePunchoutCatalogue: { method: 'post', path: '/catalogues/{id}/update' },
} as const
